import { inject, InjectionKey, provide } from '@nuxtjs/composition-api'
import { injectProductList } from './useProductList'
import { ProductEvents } from './useProduct'
import { useEvents } from '~/composables/framework/useEvents'
import {
  FilterFields,
  ListType,
  ProductListOptions,
} from '~/types/product'

export const useProductSearch = () => {
  const { emit } = useEvents()

  const base = injectProductList()

  const initialize = async (query: string) => {
    emit(ProductEvents.Search, {
      term: query,
    })

    await base.ensureOptions(() => {
      const option: ProductListOptions = {
        listType: ListType.Search,
        prefilters: query
          ? [
              {
                field: FilterFields.Query,
                value: query,
              },
            ]
          : [],
      }
      return option
    })
    await base.loadProducts(true)
  }

  return {
    ...base,
    initialize,
  }
}

// provide productSearch
const ProductSearchProviderKey: InjectionKey<
  ReturnType<typeof useProductSearch>
> = Symbol('Provider:ProductSearch')

export const provideProductSearch = () => {
  const result = useProductSearch()

  provide(ProductSearchProviderKey, result)
}

// inject productSearch
export const injectProductSearch = () => {
  const result = inject(ProductSearchProviderKey)
  if (!result) {
    throw new Error('product search provider not set')
  }

  return result
}
